import React, { useRef } from "react";
import { Box } from "@mui/system";
import {
  Button,
  Container,
  Grid,
  Link,
  TextField,
  Typography,
} from "@mui/material";
import emailjs from "emailjs-com";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import GitHubIcon from "@mui/icons-material/GitHub";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

const input = {
  width: "90%",
  marginBottom: "20px",
};

const contact = {
  backgroundColor: "#111a28",
  color: "#fff",
  padding: "5% 0%",
  marginTop: "0px",
};

export const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_55v49w6",
        "template_10un57o",
        form.current,
        "YIRA2zFOCvrUcdkUk"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
    e.target.reset();
  };

  return (
    <Box id="contact" style={contact}>
      <Container sx={{ flexGrow: 1 }}>
        <h1 className="pseudo">Contuct Me</h1>
        <Grid container spacing={4}>
          <Grid
            sx={{ display: "flex", alignItems: "center" }}
            item
            xs={12}
            md={7}
          >
            <Box
              sx={{
                padding: "3% 0%",
                backgroundColor: "#afb4bc",
                borderRadius: "5px",
                width: "100%",
              }}
            >
              <form ref={form} onSubmit={sendEmail}>
                <TextField
                  style={input}
                  id="standard-basic"
                  label="Your Name"
                  name="name"
                  variant="standard"
                />
                <br />
                <TextField
                  style={input}
                  id="standard-basic"
                  label="Email"
                  name="email"
                  variant="standard"
                />
                <br />
                <TextField
                  style={input}
                  id="standard-basic"
                  label="Subject"
                  name="subject"
                  variant="standard"
                />
                <br />
                <TextField
                  style={input}
                  id="filled-textarea"
                  placeholder="message"
                  name="message"
                  multiline
                  variant="standard"
                />
                <br />
                <Button
                  style={{ width: "50%", padding: "10px" }}
                  variant="contained"
                  type="submit"
                  value="Send"
                >
                  Send
                </Button>
              </form>
            </Box>
          </Grid>

          <Grid item xs={12} md={5}>
            <Box sx={{ textAlign: "left" }}>
              {/* Address */}
              <Grid container alignItems="center" spacing={1}>
                <Grid item>
                  <Typography variant="h6">Address</Typography>
                  <Typography variant="body2">
                    Dhamusa, Dashar, Madaripur, <br />
                    Dhaka, Bangladesh-7900
                  </Typography>
                </Grid>
              </Grid>

              {/* Social */}
              <Grid container alignItems="center" spacing={1} sx={{ mt: 1 }}>
                <Grid item>
                  <Typography variant="h6">Facebook / WhatsApp</Typography>
                  <Link
                    sx={{
                      fontSize: 14,
                      color: "white",
                      textDecoration: "none",
                      "&:hover": {
                        color: "white",
                        textDecoration: "underline",
                      },
                    }}
                    target="_blank"
                    href="https://www.facebook.com/bepari.prantosh.5/"
                  >
                    <FacebookIcon sx={{ fontSize: 20, m: 1, color: "#fff" }} />
                    Facebook
                  </Link>

                  <Link
                    sx={{
                      fontSize: 14,
                      color: "white",
                      textDecoration: "none",
                      "&:hover": {
                        color: "white",
                        textDecoration: "underline",
                      },
                    }}
                    target="_blank"
                    href="https://api.whatsapp.com/send?phone=8801833078059"
                  >
                    <WhatsAppIcon sx={{ fontSize: 20, m: 1, color: "#fff" }} />
                    WhatsApp
                  </Link>
                </Grid>
              </Grid>

              {/* Professional */}
              <Grid container alignItems="center" spacing={1} sx={{ mt: 1 }}>
                <Grid item>
                  <Typography variant="h6">Linkedin / GitHub</Typography>
                  <Link
                    sx={{
                      fontSize: 14,
                      color: "white",
                      textDecoration: "none",
                      "&:hover": {
                        color: "white",
                        textDecoration: "underline",
                      },
                    }}
                    target="_blank"
                    href="https://www.linkedin.com/in/prantosh-bepari/"
                  >
                    <LinkedInIcon sx={{ fontSize: 20, m: 1, color: "#fff" }} />
                    LinkedIn
                  </Link>

                  <Link
                    sx={{
                      fontSize: 14,
                      color: "white",
                      textDecoration: "none",
                      "&:hover": {
                        color: "white",
                        textDecoration: "underline",
                      },
                    }}
                    target="_blank"
                    href="https://github.com/PrantoshBepari360"
                  >
                    <GitHubIcon sx={{ fontSize: 20, m: 1, color: "#fff" }} />
                    GitHub
                  </Link>
                </Grid>
              </Grid>

              {/* Email */}
              <Grid container alignItems="center" spacing={1} sx={{ mt: 1 }}>
                <Grid item>
                  <Typography variant="h6">E-mail / Skype</Typography>
                  <Typography variant="body2">
                    <Link
                      sx={{
                        fontSize: 14,
                        color: "white",
                        textDecoration: "none",
                        "&:hover": {
                          color: "white",
                          textDecoration: "underline",
                        },
                      }}
                      href="mailto:bepariprantosh360@gmail.com"
                    >
                      bepariprantosh360@gmail.com
                    </Link>
                  </Typography>
                  <Typography variant="body2">
                    <Link
                      sx={{
                        fontSize: 14,
                        color: "white",
                        textDecoration: "none",
                        "&:hover": {
                          color: "white",
                          textDecoration: "underline",
                        },
                      }}
                      href="mailto:prantoshbepari@outlook.com"
                    >
                      prantoshbepari@outlook.com
                    </Link>
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Contact;
